export const formData=(obj)=>{
    let data=new FormData()
    for(const prop in obj){
        data.append(prop,obj[prop])
    }
    return data
}